// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue'
import App from './App'

import qs from 'qs'

import ui from './utils/ui'
import router from './utils/router'
import axios from './utils/interceptors'
import oss from './utils/oss'
import chart from './utils/chart'
import global from './config/global'
import api from './config/api'
import tool from './utils/tool'

// import BaiduMap from 'vue-baidu-map'
import VueLoadImage from 'vue-load-image'

import PVImageDialog from '@/components/PreviewImageDialog'
import PVVideoDialog from '@/components/PreviewVideoDialog'
import ProductAddDialog from '@/components/ProductAddDialog'
import OpusStatusDialog from '@/components/OpusStatusDialog'
import OpusRetrievalDialog from '@/components/OpusRetrievalDialog'
import OrderAddDialog from '@/components/OrderAddDialog'
import UserPasswordDialog from '@/components/UserPasswordDialog'
import UploadButton from '@/components/UploadButton'
import UploadDrawer from '@/components/UploadDrawer'

Vue.prototype.qs = qs
Vue.prototype.oss = oss

Vue.prototype.axios = axios
Vue.prototype.global = global
Vue.prototype.api = api
Vue.prototype.tool = tool

Vue.component('vue-load-image', VueLoadImage)

Vue.component('ch-image-dialog', PVImageDialog)
Vue.component('ch-video-dialog', PVVideoDialog)
Vue.component('product-add-dialog', ProductAddDialog)
Vue.component('opus-status-dialog', OpusStatusDialog)
Vue.component('opus-retrieval-dialog', OpusRetrievalDialog)
Vue.component('order-add-dialog', OrderAddDialog)
Vue.component('user-pwd-dialog', UserPasswordDialog)
Vue.component('up-button', UploadButton)
Vue.component('up-drawer', UploadDrawer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  ui,
  chart,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js